import { checkDefined } from 'faro-common-model';
export function toBaseStudyEntity(baseStudyEntity, entityType) {
    checkDefined(baseStudyEntity.studyId, 'entity', 'studyId');
    checkDefined(entityType, 'entity', 'entityType');
    return {
        id: baseStudyEntity.id,
        entityType: entityType,
        studyId: baseStudyEntity.studyId,
        deleted: baseStudyEntity.deleted || false,
        created: typeof baseStudyEntity.created === 'string'
            ? new Date(Date.parse(baseStudyEntity.created))
            : baseStudyEntity.created,
        updated: typeof baseStudyEntity.updated === 'string'
            ? new Date(Date.parse(baseStudyEntity.updated))
            : baseStudyEntity.updated,
        createdBy: baseStudyEntity.createdBy,
        revision: baseStudyEntity.revision,
    };
}
//# sourceMappingURL=study-entity.js.map